export default function reducer(state = {
  procesosSincronizacionApp: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_PROCESOS_SINCRONIZACION_APP": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}